import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseDrawerComponent } from '@fuse/components/drawer/drawer.component';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import {
  CommonFormFooterComponent
} from '../../../../../shared/src/lib/shared-components/common-form-footer/common-form-footer.component';
import {
    CommonDrawerFooterComponent
} from '../../../../../shared/src/lib/shared-components/common-drawer-footer/common-drawer-footer.component';

@NgModule({
    declarations: [
        FuseDrawerComponent
    ],
    imports: [
        CommonModule,
        MatIcon,
        MatIconButton,
        CommonFormFooterComponent,
        CommonDrawerFooterComponent,
    ],
    exports     : [
        FuseDrawerComponent
    ]
})
export class FuseDrawerModule
{
}
